import { withStyles } from '@material-ui/core';

import Reference from './component';
import styles from './styles';

export default withStyles(styles)(Reference);
